/**
 * @deprecated 不允许再使用此配置文件，请使用多语言配置
 */
export const SystemCode = {
    // 系统最基础的报错信息,让用于稍后重试
    A100O000: "",
    // API基础报错,请求失败,让用户稍后重试
    A101B000: "Request an exception, Please try again later",
    // A101B001~A101B100 预留作为个人中心信息报错
    // 缺少路由页面包屑默认路径
    A101B001: "The default path is missing",
    A101B002: "Deleted Successfully",
    A101B003: "Saved Successfully",
    A101B004: "Modified Successfully",
    A101B005: "Added Successfully",
    A101B006: "Delete Failed",
    // 初始化失败,请刷新重试
    A101B007: "Initialization failed,Please refresh and try again",
    A101B008: "Copy Successfully",
    A101B009: "Copy Failed"
}